import { useContext, useEffect, useState } from 'react';
import Inputs from './components/inputs';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import { TabContext } from '../../../Context/TabContext';
import TabsProvider from './components/TabsProvider';
import { isFormValid } from './validation/isFormValid';
import { useTranslation } from 'react-i18next';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import DetaljiRN from './DetaljiRN';
import MultiSelectDialog from '../../UI/MultiSelectDialog/MultiSelectDialog';
import Dnevnik from './Dnevnik/Dnevnik';
import Beleske from './Beleske/Beleske';
import Izvestaji from './Izvestaji';
// import IzvestajRadnogNalogaDialog, {
//   TIP_IZVESTAJA,
// } from '../shared/IzvestajRadnogNaloga/IzvestajRadnogNalogaDialog';

const INITIAL_VALUES = {
  idDok: 0,
  ceoBrDok: '',
  datum: null,
  idKorProm: +localStorage.getItem('idKorisnika'),
  napomena: '',
  idDokServisnogZahteva: null,
  datumZavrsetka: null,
  opisRadova: '',
  idKupca: 0,
  nazivKupca: '',
  idMasine: null,
  nazivMasine: '',
  idPodProjekta: null,
  nazivPodProjekta: '',
  zavrsen: false,
  naplacujeSe: false,
};
const INITIAL_ZAHTEV_VALUES = {
  id: 0,
  idDok: 0,
  ceoBrDok: '',
  idStatusa: 0,
  status: '',
  metadataStatusa: '',
  idMasine: 0,
  nazivMasine: '',
  naslov: '',
  opisProblema: '',
  datumZatvaranja: null,
  idPrioriteta: null,
  kodGreske: '',
  brojSatiRada: 0,
  opisProblemaDetaljan: null,
  idKorProm: 0,
  vremeProm: null,
  idKorKreiranja: 2,
  vremeKreiranja: null,
  idStatusaMasine: 0,
  statusMasine: '',
  vrsteKvarova: null,
  napomena: null,
  poslato: false,
  datumSlanja: null,
  IdKupcaKorisnikaPrograma: 0,
  NazivFirmeKorisnikaPrograma: '',
  listaVrstaKvarova: [],
};

const PregledPustanjaMasine = ({
  save,
  handleSave,
  detail,
  handleDetail,
  handleDisableDetail,
  dodeliZaposlenima,
  handleDodeliZaposlenima,
  dnevnik,
  handleDnevnik,
  beleske,
  handleBeleske,
  izvestaji,
  handleIzvestaji,
  handleDisableDodeliZaposlenima,
  pdfIzvestaj,
  handlePdfIzvestaj,
}) => {
  const { t, i18n } = useTranslation();
  // const [openPdfIzvestaj, setOpenPdfIzvestaj] = useState(false);
  const { tabsData, activeComponent } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const radniNalogLocal = dataLocal?.data ? dataLocal?.data : INITIAL_VALUES;
  console.log(radniNalogLocal);
  const { getData } = useHttp('');
  const { sendRequest: getZaposleni, data: zaposleniData } = useHttp('');
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [servisniZahtevValues, setServisniZahtevValues] = useState(
    INITIAL_ZAHTEV_VALUES,
  );
  const [dataPonude, setDataPonude] = useState({});
  const [openPregledRN, setOpenPregledRN] = useState(false);
  const [showSuma, setShowSuma] = useState({
    zaposleni: false,
    transport: false,
    delovi: false,
    troskovi: false,
    zaglavlje: false,
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [secondSelectedItems, setSecondSelectedItems] = useState([]);
  const [openDnevnik, setOpenDnevnik] = useState(false);
  const [openBelekse, setOpenBelekse] = useState(false);
  const [openIzvestaji, setOpenIzvestaji] = useState(false);
  // vracanje zaposlenih
  useEffect(() => {
    getZaposleni({ url: urls.GET_ZAPOSLENI_COMBO });
  }, []);
  // otvaranje dijaloga za dodeljivanje radnog naloga
  useEffect(() => {
    if (dodeliZaposlenima) {
      setOpenDialog(dodeliZaposlenima);
    }
    handleDodeliZaposlenima(false);
  }, [dodeliZaposlenima]);

  useEffect(() => {
    if (dnevnik) {
      setOpenDnevnik(true);
    }
    handleDnevnik(false);
  }, [dnevnik]);
  useEffect(() => {
    console.log('BELESTE', beleske);
    if (beleske) {
      setOpenBelekse(true);
    }
    handleBeleske(false);
  }, [beleske]);
  useEffect(() => {
    if (localStorage.sa !== 'true' || !radniNalogLocal?.idDok) {
      handleDisableDetail(true);
    } else {
      handleDisableDetail(false);
    }
  }, []);

  useEffect(() => {
    if (!radniNalogLocal?.idDok) {
      console.log('first');
      handleDisableDodeliZaposlenima(true);
    } else {
      console.log('first2');
      handleDisableDodeliZaposlenima(false);
    }
  }, []);

  const vratiServisniZahtev = async (id) => {
    const config = {
      method: 'POST',
      url: urls.GET_SERVISNI_ZAHTEV_ZA_ID,
      data: { id: id, metadata: i18n.language },
    };
    const response = await getData(config);
    if (response.id > 0) {
      setFormValues({
        ...INITIAL_VALUES,
        nazivKupca: response.NazivFirmeKorisnikaPrograma,
        idKupca: response.IdKupcaKorisnikaPrograma,
        idMasine: response.idMasine,
        nazivMasine: response.nazivMasine,
        idDokServisnogZahteva: response.idDok,
        idPodProjekta: response.idPodProjekta,
        nazivPodProjekta: response.nazivPodProjekta,
      });
      setServisniZahtevValues(response);
    }
  };
  const vratiServisniZahtevIzmenaNaloga = async (id) => {
    const config = {
      method: 'POST',
      url: urls.GET_SERVISNI_ZAHTEV_ZA_ID,
      data: { id: id, metadata: i18n.language },
    };
    const response = await getData(config);
    if (response.id > 0) {
      setServisniZahtevValues(response);
    }
  };
  // vraca zaposlene kojima je dodeljen radni nalog
  const vratiZaposleneZaRadniNalog = async (id) => {
    const config = {
      method: 'POST',
      url: urls.GET_ZAPOSLENI_ZA_RN,
      data: { id: id },
    };
    const result = await getData(config);
    setSelectedItems(result);
    const komisijaList = result.filter((item) => item.komisija === true);
    setSecondSelectedItems(komisijaList);
  };
  useEffect(() => {
    if (radniNalogLocal.prenetiIdServisnogZahteva > 0) {
      // console.log('IZ SERVISNOG ZAHTEVA');
      vratiServisniZahtev(radniNalogLocal.prenetiIdServisnogZahteva);
    } else {
      // console.log(// console.log('IZ RADNOG NALOGA'));
      vratiServisniZahtevIzmenaNaloga(radniNalogLocal.idDokServisnogZahteva);
      console.log(radniNalogLocal);
      vratiZaposleneZaRadniNalog(radniNalogLocal.idDok);
      setFormValues(radniNalogLocal);
    }
  }, [i18n.language]);

  const handleSaveData = async () => {
    if (isFormValid(formValues)) {
      return;
    }
    const config = {
      method: 'POST',
      url: urls.INSERT_UPDATE_RADNI_NALOG,
      data: {
        ...formValues,
        id: formValues.idDok,
        idKorProm: +localStorage.getItem('idKorisnika'),
      },
    };
    const response = await getData(config);
    if (response.idDok > 0) {
      setFormValues(response);

      toast.success(
        formValues.idDok === 0
          ? 'Uspešan unos podatak'
          : 'Uspešna izmena podataka',
      );
      handleDisableDodeliZaposlenima(false);
      return;
    }
    toast.error(handleErrorMessage(response));
  };
  const vratiDetaljeRN = async () => {
    const config = {
      method: 'POST',
      url: urls.VRATI_PREGLED_SERVISA,
      data: {
        id: radniNalogLocal.idDok,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);
    setDataPonude(response);
    setOpenPregledRN(true);
  };
  const handleIsExpanded = (e, expanded, name) => {
    console.log(name);
    setShowSuma((curr) => {
      return { ...curr, [name]: expanded };
    });
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);

  useEffect(() => {
    if (detail) {
      vratiDetaljeRN();
      handleDetail(false);
    }
  }, [detail]);
  const handleClose = () => {
    setOpenDialog(false);
  };
  // funkcija za upisivanje liste zaposlenih za radni nalog
  const handleDodeliZaposlenimaRadniNalog = async () => {
    console.log('lista', selectedItems);
    console.log('lista komisija', secondSelectedItems);

    const listaZaposlenih = selectedItems.map((item) => {
      const isKomisija = secondSelectedItems.find(
        (item2) => item2.id === item.id,
      );
      console.log('isKomisija', isKomisija);
      if (isKomisija) {
        return { ...item, komisija: true };
      }
      return { ...item, komisija: false };
    });
    console.log('Lista zaposlenih sa komisijom', listaZaposlenih);
    console.log(listaZaposlenih);
    const config = {
      method: 'POST',
      url: urls.DODELI_ZAPOSLENIMA,
      data: {
        id: formValues.idDok,
        idKorProm: +localStorage.getItem('idKorisnika'),
        listaZaposlenih: listaZaposlenih,
      },
    };
    const result = await getData(config);
    toast.success('Uspešno dodeljen radni nalog.');
    console.log(result);
  };

  useEffect(() => {
    if (izvestaji) {
      setOpenIzvestaji(true);
    }
    handleIzvestaji(false);
  }, [izvestaji]);

  // useEffect(() => {
  //   if (pdfIzvestaj) {
  //     if (formValues.idDok) setOpenPdfIzvestaj(true);
  //     handlePdfIzvestaj(false);
  //   }
  // }, [pdfIzvestaj]);
  return (
    <div>
      {/* <IzvestajRadnogNalogaDialog
        open={openPdfIzvestaj}
        idDok={formValues.idDok}
        tip={TIP_IZVESTAJA.PUR}
        onClose={() => setOpenPdfIzvestaj(false)}
      /> */}
      <Inputs
        formValues={formValues}
        setFormValues={setFormValues}
        servisniZahtevValues={servisniZahtevValues}
      />

      <TabsProvider
        idRn={formValues.idDok}
        naplacujeSe={formValues.naplacujeSe}
      />
      <MuiDialog
        maxWidth="xl"
        open={openPregledRN}
        title="Troškovi"
        content={
          <DetaljiRN
            dataPonude={dataPonude}
            showSuma={showSuma}
            handleIsExpanded={handleIsExpanded}
            naplacujeSe={formValues.naplacujeSe}
          />
        }
        handleClose={() => {
          setOpenPregledRN(false);
          setShowSuma({
            zaposleni: false,
            transport: false,
            delovi: false,
            troskovi: false,
            zaglavlje: false,
          });
        }}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="xl"
        open={openDnevnik}
        title={t('dnevnik')}
        content={<Dnevnik rnValues={formValues} />}
        handleClose={() => setOpenDnevnik(false)}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="xl"
        open={openBelekse}
        title="Beleške"
        content={<Beleske rnValues={formValues} />}
        handleClose={() => setOpenBelekse(false)}
        deniedText="ZATVORI"
      />
      <MultiSelectDialog
        secondSelect
        data={zaposleniData}
        openDialog={openDialog}
        handleClose={handleClose}
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        handleConfirm={handleDodeliZaposlenimaRadniNalog}
        secondSelectName="Komisija"
        setSecondSelectedItems={setSecondSelectedItems}
        secondSelectedItems={secondSelectedItems}
      />

      <MuiDialog
        maxWidth="xl"
        open={openIzvestaji}
        title="Izveštaji"
        content={<Izvestaji idNaloga={formValues.idDok} />}
        handleClose={() => setOpenIzvestaji(false)}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default PregledPustanjaMasine;
